import { render, staticRenderFns } from "./MiniStatsIconCard2.vue?vue&type=template&id=2f2bce02&scoped=true"
import script from "./MiniStatsIconCard2.vue?vue&type=script&lang=js"
export * from "./MiniStatsIconCard2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2bce02",
  null
  
)

export default component.exports